'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var PropTypes = _interopDefault(require('prop-types'));

/**
 * FormField helper to define some props
 * @param {*} props 
 */

var FormField = function FormField(props) {
  var requiredLabel = props.requiredLabel,
      optionalLabel = props.optionalLabel;
};

FormField.propTypes = {
  requiredLabel: PropTypes.string,
  optionalLabel: PropTypes.string,
  // eslint-disable-next-line react/no-unused-prop-types
  errorTitle: PropTypes.string
};
FormField.defaultProps = {
  errorTitle: ' '
};

module.exports = FormField;
